import { useTranslation } from "react-i18next";
import { Seo } from "@/components/Seo";
import { PageHero } from "@/components/PageHero";

/**
 * Minimal Terms of Use stub. Content to be reviewed by the site owner.
 */
const Terms = () => {
  const { t } = useTranslation();
  return (
    <>
      <Seo
        title="Terms of Use"
        description="Terms of use for the Doctors Vietnam website and healthcare coordination service."
        path="/terms"
      />
      <PageHero
        eyebrow="Terms"
        title="Terms of Use"
        subtitle="Please read these terms carefully before using our website or service."
        crumbs={[{ label: t("nav.home"), to: "/" }, { label: "Terms" }]}
      />
      <section className="vc-container prose prose-slate max-w-3xl py-14 sm:py-16">
        <p><strong>Effective date:</strong> {new Date().toLocaleDateString("en-GB", { year: "numeric", month: "long", day: "numeric" })}</p>
        <h2>About Doctors Vietnam</h2>
        <p>Doctors Vietnam is an independent healthcare coordination and patient-support service. We are not a hospital, clinic, ambulance service or emergency department, and we do not diagnose or provide medical treatment. Medical services are provided by independent licensed doctors, clinics and hospitals.</p>
        <h2>Emergencies</h2>
        <p>For life-threatening emergencies in Vietnam, call 115 or go directly to the nearest hospital emergency department. Doctors Vietnam provides non-emergency coordination only.</p>
        <h2>No medical advice</h2>
        <p>Information on this website is for general guidance and does not constitute medical advice, diagnosis or treatment. Always consult a qualified healthcare professional about any medical concern.</p>
        <h2>Coordination service</h2>
        <p>Where we coordinate care, availability, timing and pricing are confirmed individually with the independent provider. We do not warrant any specific outcome and are not liable for the acts or omissions of independent providers.</p>
        <h2>Use of the website</h2>
        <p>You agree to use the website only for lawful purposes. You must not attempt to disrupt, exploit or misuse the service.</p>
        <h2>Contact</h2>
        <p>Questions? Email <a href="mailto:support@vietclinics.com">support@vietclinics.com</a>.</p>
        <p className="text-xs text-[hsl(var(--vc-slate))]">This is a general terms statement. For legally binding terms tailored to your jurisdiction, please seek legal review.</p>
      </section>
    </>
  );
};

export default Terms;
